import { Avatar } from "antd";
import { useEffect, useState } from "react";

import { getMediaUrl } from "../../utils/mediaUrl";

const IDENTITY_PALETTE = [
  { accent: "#5ec8ff", soft: "#12364d", text: "#f4fbff" },
  { accent: "#7bd88f", soft: "#173d24", text: "#f8fff9" },
  { accent: "#ffb86b", soft: "#4a2b12", text: "#fff8ef" },
  { accent: "#f47ea4", soft: "#481827", text: "#fff5f8" },
  { accent: "#b49cff", soft: "#302452", text: "#fbf8ff" },
  { accent: "#65e0c8", soft: "#123d38", text: "#f3fffd" },
  { accent: "#f4d35e", soft: "#443815", text: "#fffcef" },
  { accent: "#ff8f70", soft: "#4b2118", text: "#fff6f2" },
];

const getIdentityHash = (value = "") => {
  const text = String(value || "");
  let hash = 0;

  for (let index = 0; index < text.length; index += 1) {
    hash = (hash * 31 + text.charCodeAt(index)) % 2147483647;
  }

  return hash;
};

export const getIdentityAvatarStyle = (identity = "") => {
  const colors = IDENTITY_PALETTE[
    getIdentityHash(identity) % IDENTITY_PALETTE.length
  ];

  return {
    "--chat-avatar-accent": colors.accent,
    "--chat-avatar-accent-soft": colors.soft,
    "--chat-avatar-text": colors.text,
  };
};

const UserAvatar = ({ src, fallbackSrc, identity, children, className = "", style, ...props }) => {
  const normalizedSrc = getMediaUrl(src);
  const normalizedFallback = getMediaUrl(fallbackSrc);
  const [failedSources, setFailedSources] = useState([]);
  const imageSrc = [normalizedSrc, normalizedFallback].find(value => value && !failedSources.includes(value));
  const hasImage = Boolean(imageSrc);
  const identityStyle = hasImage ? {} : getIdentityAvatarStyle(
    identity || children || normalizedSrc,
  );

  useEffect(() => setFailedSources([]), [normalizedSrc, normalizedFallback]);

  return (
    <Avatar
      {...props}
      className={[
        "userAvatar",
        hasImage ? "" : "userAvatar--fallback",
        className,
      ].filter(Boolean).join(" ")}
      onError={() => {
        setFailedSources(current => [...new Set([...current, imageSrc])]);
        return false;
      }}
      src={imageSrc}
      style={{ ...identityStyle, ...style }}
    >
      {children}
    </Avatar>
  );
};

export default UserAvatar;
